export default __webpack_public_path__ + "static/media/02.202a0711.png";